// Import model
import { AiContentMessage } from '../models/AiContentMessage';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for AiContentMessage - handles JSON serialization and deserialization with type validation
 */
export class AiContentMessageSerializer {
  /**
   * Deserializes a JSON string into a AiContentMessage instance
   */
  static deserialize(json: string): AiContentMessage {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a AiContentMessage instance
   */
  static fromObject(obj: any): AiContentMessage {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to AiContentMessage');
    }


    const instance: AiContentMessage = {
      assistantFeedback: obj['AssistantFeedback'] as string | undefined,
      chatDescription: obj['ChatDescription'] as string | undefined,
      chatName: obj['ChatName'] as string | undefined,
      content: obj['Content'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of AiContentMessage instances
   */
  static deserializeArray(json: string): AiContentMessage[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a AiContentMessage instance to a JSON string
   */
  static serialize(instance: AiContentMessage): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a AiContentMessage instance to a plain object
   */
  static toObject(instance: AiContentMessage): any {
    return {
      'AssistantFeedback': instance.assistantFeedback,
      'ChatDescription': instance.chatDescription,
      'ChatName': instance.chatName,
      'Content': instance.content,
    };
  }

  /**
   * Serializes an array of AiContentMessage instances to a JSON string
   */
  static serializeArray(instances: AiContentMessage[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
